import request from '@/utils/request'

export function addProduct(code, quantity, price, observationDetail, type, typeDocument, in_location, branchId, userId, inventoryAuditId, editing, documentId, thirdId, numDays, observation, document_reference, costCenterId) {
  return request({
    url: 'inputOutputAdjust/validateProduct',
    method: 'post',
    data: {code, quantity, price, observationDetail, type, typeDocument, in_location, branchId, userId, inventoryAuditId, editing, documentId, thirdId, numDays, observation, document_reference, costCenterId}
  });
}

export function getAuditory(auditory_id) {
  return request({
    url: 'inputOutputAdjust/getAuditory/' + auditory_id,
    method: 'get'
  });
}

export function getAdjustInputOutput(page_size, current_page,  branch_id, type_document, document, dates) {
  return request({
    url: 'inputOutputAdjust/get/' + page_size + '/' + branch_id + '/' + type_document + '/' + document + '/' + dates + '?page=' + current_page,
    method: 'get'
  });
}

export function getAdjustInputOutputPending(branch_id, type_document) {
  return request({
    url: 'inputOutputAdjust/pending/' + branch_id + '/' + type_document,
    method: 'get'
  });
}

export function saveAdjustInputOutput(document, inventoryAuditId, userId, branchId, transaction, typeDocument, costCenterId) {
  return request({
    url: 'inputOutputAdjust/save',
    method: 'post',
    data: { document, inventoryAuditId, userId, branchId, branchDestinationId: (document.branchDestination) ? document.branchDestination.id : null, transaction, typeDocument, costCenterId }
  });
}

export function updateAdjustInputOutput(document) {
  return request({
    url: 'inputOutputAdjust/update',
    method: 'put',
    data: { document, branch: document.branch, branchDestination: document.branchDestination}
  });
}

export function deleteRowDetail(id, productId, branchId, editing) {
  return request({
    url: 'inputOutputAdjust/deleteRowDetail',
    method: 'post',
    data: { id, productId, branchId, editing }
  });
}

export function cancelDocument(data) {
  return request({
    url: 'inputOutputAdjust/cancelDocument',
    method: 'post',
    data
  });
}

export function importExcel(formData) {
  return request({
    url: 'inputOutputAdjust/importExcel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function downloadTemplate() {
  return request({
    url: 'inputOutputAdjust/downloadTemplate',
    method: 'get',
    responseType: 'blob'
  });
}
